// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12lz5","option":"styles_option__28GnO","active":"styles_active__xA34d"};